export default __webpack_public_path__ + "static/media/182.43404c06.png";